var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusFilter(_vm.product.updateApproveStatus))?_c('span',[_vm._v(" "+_vm._s(_vm.statusFilter(_vm.product.updateApproveStatus))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }